export default __webpack_public_path__ + "4b2df1cf53d4cc96cd3a801145ae01c3.png";